import { useEffect, useRef } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function MultiPulsePage() {
  const canvasRef = useRef(null);
  const pulses = useRef([]);

  // 🎯 конфиг сетей
  const networks = {
    ETH: { color: "#9b5cff" },
    BSC: { color: "#f3ba2f" },
    TRON: { color: "#ff3b3b" },
    POLY: { color: "#2bbdf7" },
    ARB: { color: "#00ffc3" },
    BASE: { color: "#4caf50" },
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight - 120;
    };

    resize();
    window.addEventListener("resize", resize);

    // 🎯 координаты 6 зон
    const getCenters = () => {
      const w = canvas.width;
      const h = canvas.height;

      return {
        ETH: { x: w * 0.25, y: h * 0.25 },
        BSC: { x: w * 0.75, y: h * 0.25 },
        TRON: { x: w * 0.25, y: h * 0.75 },
        POLY: { x: w * 0.75, y: h * 0.75 },
        ARB: { x: w * 0.5, y: h * 0.45 },
        BASE: { x: w * 0.5, y: h * 0.85 },
      };
    };

    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};

        // ❗ ВАЖНО: подстрой под свой backend
        let chain =
          p.chain ||
          p.network ||
          msg.chain ||
          msg.network ||
          "ETH";

        chain = chain.toUpperCase();

        if (!networks[chain]) return;

        pulses.current.push({
          chain,
          radius: 10,
          alpha: 1,
          speed: 2 + Math.random() * 2,
          width: 1 + Math.random() * 2,
        });
      } catch {}
    };

    const draw = () => {
      const w = canvas.width;
      const h = canvas.height;

      ctx.fillStyle = "rgba(0,0,0,0.25)";
      ctx.fillRect(0, 0, w, h);

      const centers = getCenters();

      // 🎯 рисуем подписи сетей
      Object.entries(centers).forEach(([name, c]) => {
        ctx.fillStyle = "#888";
        ctx.font = "14px Arial";
        ctx.fillText(name, c.x - 20, c.y - 20);
      });

      // 🎯 пульсы
      pulses.current.forEach((p) => {
        const center = centers[p.chain];
        if (!center) return;

        p.radius += p.speed;
        p.alpha -= 0.01;

        ctx.beginPath();
        ctx.arc(center.x, center.y, p.radius, 0, Math.PI * 2);

        ctx.strokeStyle = hexToRgba(networks[p.chain].color, p.alpha);
        ctx.lineWidth = p.width;
        ctx.stroke();
      });

      // очистка
      pulses.current = pulses.current.filter((p) => p.alpha > 0);

      requestAnimationFrame(draw);
    };

    draw();

    return () => {
      ws.close();
      window.removeEventListener("resize", resize);
    };
  }, []);

  // 🎯 hex → rgba
  function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  }

  return (
    <div style={{ minHeight: "100vh", background: "#000" }}>
      <Header />

      <div style={{ textAlign: "center", padding: 16, color: "#fff" }}>
        <h1>⚡ Multi Network Pulse</h1>
      </div>

      <canvas ref={canvasRef} />

      <Footer />
    </div>
  );
}